import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=074a32e2&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=074a32e2&prod&scoped=true&lang=css"
import style1 from "./privacy.vue?vue&type=style&index=1&id=074a32e2&prod&scoped=true&lang=css"
import style2 from "./privacy.vue?vue&type=style&index=2&id=074a32e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a32e2",
  null
  
)

export default component.exports